import { Icon } from '@timeedit/ui-components';

const RenderIcon = ({ onExpand, record, expanded }: any) => {
  return (
    <button
      type="button"
      aria-label={expanded ? 'Collapse row' : 'Expand row'}
      aria-expanded={expanded}
      onClick={(e) => {
        onExpand(record, e);
        e.stopPropagation();
      }}
      style={{
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon
        id="CaretDownOutlined"
        alt="Caret Down"
        style={{
          transform: `rotate(${expanded ? '0deg' : '-90deg'})`,
          transitionDuration: '0.4s',
        }}
      />
    </button>
  );
};

export default RenderIcon;
